import { IsNotEmpty, IsOptional, IsString } from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

export class CreateLessonTypeDto {
  @ApiProperty({ type: 'string', description: 'Code du type de leçon', example: 'THEORY' })
  @IsNotEmpty()
  @IsString()
  code!: string

  @ApiProperty({ type: 'string', description: 'Nom du type de leçon', example: 'Théorie' })
  @IsNotEmpty()
  @IsString()
  name!: string

  @ApiPropertyOptional({ type: 'string', description: 'Description' })
  @IsOptional()
  @IsString()
  description?: string
}
